export function HomeIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 13h6v6h3v-9l-6-4.5L6 10v9h3v-6m-5 8V9l8-6 8 6v12H4z" fill="currentColor" fillRule="evenodd" />
    </svg>
  );
}
